"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalVideoButtonBG = exports.ModalVideoButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_modal_video_1 = __importDefault(require("react-modal-video"));
var _1 = require("./");
// https://appleple.github.io/react-modal-video/
// inline thumbnail image, fluid resize
var ModalVideoButton = function (_a) {
    var image = _a.image, channel = _a.channel, videoId = _a.videoId, url = _a.url;
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    if (url)
        channel = 'custom';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ onClick: function () { return setOpen(true); }, className: "position-relative shadow-lg overlay overlay-solid video-play-anchor" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: image, className: "img-fluid", alt: "" }), (0, jsx_runtime_1.jsx)(_1.VideoPlayCircle, { className: "z-2" })] })), (0, jsx_runtime_1.jsx)(react_modal_video_1.default, { channel: channel, videoId: videoId, url: url, autoplay: true, isOpen: open, onClose: function () { return setOpen(false); } })] }));
};
exports.ModalVideoButton = ModalVideoButton;
// background thumbnail image, object fit cover crops image to container
var ModalVideoButtonBG = function (_a) {
    var image = _a.image, invertedPlay = _a.invertedPlay, playSize = _a.playSize, channel = _a.channel, videoId = _a.videoId, url = _a.url;
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    if (url)
        channel = 'custom';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ onClick: function () { return setOpen(true); }, className: "overlay overlay-solid video-play-anchor w-100 h-100" }, { children: [(0, jsx_runtime_1.jsx)(_1.BackgroundImage, { src: image }), (0, jsx_runtime_1.jsx)(_1.VideoPlayCircle, { inverted: invertedPlay, size: playSize, className: "z-2" })] })), (0, jsx_runtime_1.jsx)(react_modal_video_1.default, { channel: channel, videoId: videoId, url: url, autoplay: true, isOpen: open, onClose: function () { return setOpen(false); } })] }));
};
exports.ModalVideoButtonBG = ModalVideoButtonBG;
